/* eslint-disable no-console */
import React, { Fragment, useState, useEffect } from 'react';
import { useStyles } from './yourDetails.style';
import * as yup from 'yup';
import { useFormik } from 'formik';
import Background from 'Components/Reusable/Background/Background';
import addDetails from 'Assets/img/svg/logos/addDetails.svg';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import Selector from 'Components/Selector/Selector';
import CustomRadio from 'Components/Reusable/Buttons/CustomRadio';
import { radioButtonItems } from 'Utils/options';
import { useDispatch, useSelector } from 'react-redux';
import { GetProfile } from 'ReduxStore/profile/Action';
import { GetAllKids, addKid, removeOneKid, updateKids } from 'ReduxStore/children/Action';
import { RootState } from 'ReduxStore/store';
import { Link, useHistory } from 'react-router-dom';
import { Routes } from 'Utils';
import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import CustomModal from 'Components/Modals/CustomModal';
import { conditions } from 'Utils/options';
import { cancelSubscription } from 'ReduxStore/subscription/Action';
import Header from 'Components/Header/Header';
import ClipLoader from 'react-spinners/ClipLoader';
import removeKidsImage from 'Assets/img/holders/removeKid.svg';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Error from 'Components/Timeline/Error';
import { ToWords } from 'to-words';

import CancelSubscription from 'Assets/img/holders/CancelSubscription.svg';
import { PlainInput } from 'Components/Reusable/Inputs/PlainInput';
interface State {
	fullName: string;
	dateOfBirth: string;
	gestation: string;
	gender: string;
}

const validationSchema = yup.object({
	dateOfBirth: yup.string().required('Date of birth required'),
	fullName: yup.string().required('Full name required'),
});

const AddDetails = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	// from redux store
	const children = useSelector((state: RootState) => state.children.children);
	const errors = useSelector((state: RootState) => state.children.error);

	const currentChild = localStorage.getItem('currentChild');
	// initiate and set initial state
	const [kids, setKids] = useState<any>(children && children);
	const matches = useMediaQuery('(max-width:445px)');

	useEffect(() => {
		dispatch(GetAllKids());
		return () => {
			console.log('cleaning up');
		};
	}, []);
	//second use effect
	useEffect(() => {
		if (children) {
			setKids(children);
		}
		// setKids(children?.length > 0 && children);

		return () => {
			console.log('hey i am her');
		};
	}, [children]);

	if (kids?.length < 1) {
		if (children) {
			setKids(children);
		}
	}
	const [loading, setLoading] = React.useState(true);
	const [open, setOpen] = React.useState(false);
	const [premiumOpen, setpremiumOpen] = React.useState(false);
	const [removeKid, setRemoveKid] = React.useState(false);
	const [addANewKid, setRAddANewKid] = React.useState(false);
	const formik = useFormik({
		initialValues: {
			fullName: '',
			dateOfBirth: '',
			gestation: '',
			gender: '',
			Name: '',
		},
		validationSchema: validationSchema,
		onSubmit: async values => {
			setLoading(false);
			await addKid(values.fullName, values.dateOfBirth, gestation, gender)(dispatch);
			setTimeout(() => {
				setLoading(true);
				window.location.reload();
			}, 1000);
		},
	});

	const child = [
		{
			id: 1,
			name: 'fullName',
			value: 'fullName',
			type: 'text',
			label: 'First Name',
			placeholder: '',
			defaultValue: '',
		},
		{
			id: 2,
			name: 'dateOfBirth',
			value: 'date',
			type: 'date',
			label: 'Date of Birth',
			placeholder: '',
			defaultValue: '',
		},
	];

	const [state, setState] = useState(true);
	const [gestation, setGestation] = useState('');
	const [gender, setGender] = useState('');

	const [userSubID, setUserSubID] = useState<any>('');

	const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		event.preventDefault();
		setState(!state);
	};
	const handleUpgradeSubscription = (id: any) => {
		return history.push(`/upgrade/${id}`);
	};
	const handleOpen = (id: number) => {
		return history.push(`address/${id}`);
	};
	const handleClose = () => {
		setOpen(false);
		setRemoveKid(false);
		setRAddANewKid(false);
	};
	const handleModalClick = (condition: string, id: number) =>
		condition === 'yes' ? history.push(`/membership/${id}`) : setOpen(false);
	const handlePremiumOpen = (id: any) => {
		setUserSubID(id);
		setpremiumOpen(true);
	};
	const handlePremiumClose = () => {
		setpremiumOpen(false);
		setRemoveKid(false);
		setRAddANewKid(false);
	};
	const openRemoveKidModal = () => setRemoveKid(!removeKid);
	// const handleRemoveKid = (condition: string, id: number) => {
	// 	if (id) {
	// 		condition === 'yes'
	// 			? removeOneKid(id)(dispatch) &&
	// 			  setTimeout(() => {
	// 					setLoading(true);
	// 					window.location.reload();
	// 			  }, 2500)
	// 			: setRemoveKid(false);
	// 	} else {
	// 		setRemoveKid(false);
	// 	}
	// };
	const handlePremiumModalClick = async (condition: string, id: number) => {
		if (id) {
			if (condition == 'yes') {
				cancelSubscription(id)(dispatch);
				setTimeout(() => {
					setLoading(true);
					window.location.reload();
				}, 3000);
			} else {
				setpremiumOpen(false);
			}
			// condition === 'yes'
			// ? cancelSubscription(id)(dispatch) &&
			//   setTimeout(() => {
			// 		setLoading(true);
			// 		window.location.reload();
			//   }, 3000)
			// 	: setpremiumOpen(false);
		} else {
			setpremiumOpen(false);
		}
	};
	const openAddChildModal = () => {
		setRAddANewKid(!addANewKid);
	};

	const changeDate = (date: string) => {
		const todayDate = new Date(date).toISOString().slice(0, 10);
		return todayDate;
	};
	const list = [
		{ id: 1, name: 'Preterm' },
		{ id: 2, name: 'Term' },
	];
	const homes = () => {
		return history.push(Routes.Menu);
	};
	const toWords = new ToWords();
	const onGestationUpdate = (value: any, childId: any) => {
		const newdata = kids?.map((child: any) => {
			if (child.id === childId) {
				return { ...child, status: value === 'Term' ? 'term' : 'preterm' };
				// return setKids([]);
			}
			return { ...child };
		});

		setKids(newdata);
	};
	const onGenderUpdate = (value: any, childId: any) => {
		const newdata = kids?.map((child: any) => {
			if (child.id === childId) {
				return { ...child, gender: value === 'boy' ? 'MALE' : 'FEMALE' };
				// return setKids([]);
			}
			return { ...child };
		});
		setKids(newdata);
	};
	const onNameUpdate = (value: any, childId: any) => {
		const newdata = kids?.map((child: any) => {
			if (child.id === childId) {
				if (child.id == localStorage.getItem('currentChildId')) {
					localStorage.removeItem('currentChild');
					localStorage.setItem('currentChild', value);
					console.log('alas');
				}
				return { ...child, fullName: value };
			}
			return { ...child };
		});

		setKids(newdata);
	};

	const onDateUpdate = (value: any, childId: any) => {
		const newdata = kids?.map((child: any) => {
			if (child.id === childId) {
				return { ...child, dateOfBirth: value };
			}
			return { ...child };
		});

		setKids(newdata);
	};
	const handlemysubmit = () => {
		dispatch(updateKids(kids));
		// cocurrentChild = localStorage.getItem('currenChildId');
		setTimeout(() => {
			setLoading(true);
			// window.location.reload();
			history.push(Routes.Menu);
		}, 2500);
	};
	return (
		<Fragment>
			{kids && kids.length > 0 ? (
				<section>
					<div
						className={classes.mobileBackground}
						style={{
							height: matches ? '247.86px;' : '',
							justifyContent: matches ? 'center' : 'flex-end',
						}}
					>
						<div className={classes.mobileBackground}>
							<div className={classes.goBack}>
								<Link
									className={classes.links}
									style={{ color: matches ? '#0d6efd' : 'white' }}
									to={Routes.Menu}
								>
									Back
								</Link>
							</div>
						</div>
					</div>
					<Background middleItem={addDetails} height={state ? 'auto' : '100vh'} row>
						<div className={`${classes.background} px-3 mx-auto mt-5`}>
							<ul className={`${classes.listItems} mb-3`}>
								{children &&
									children?.map((childs: any, i: any) => (
										<div key={childs.id} className={classes.childBackground}>
											<small className="text-center d-flex justify-content-center my-4">
												Child {toWords.convert(i + 1)}
											</small>
											<li className="mt-2">
												<PlainInput
													name="Full name"
													label="First Name"
													type="text"
													placeholder=""
													fvalue={childs.fullName}
													width="381.87px"
													height="53.91px"
													defaultValue={childs.fullName}
													onChange={onNameUpdate}
													childId={childs.id}
												/>
											</li>
											<li className="mt-2">
												<PlainInput
													name="Date of birth"
													type="date"
													placeholder=""
													formik={formik}
													width="381.87px"
													height="53.91px"
													label="Date of Birth"
													defaultValue={changeDate(childs.dateOfBirth)}
													onChange={onDateUpdate}
													childId={childs.id}
												/>
											</li>

											<div className="d-flex flex-column flex-wrap mx-auto mt-4 mb-3 justify-content-center align-items-center">
												<section className="mb-3">
													<Selector
														itemList={list}
														gestation={setGestation}
														defaultValue={childs.status}
														onClickPass={onGestationUpdate}
														childId={childs.id}
													/>
												</section>
												<CustomRadio
													items={radioButtonItems}
													defaultValue={childs.gender != 'MALE' ? 'girl' : 'boy'}
													genderChoice={setGender}
													componentWidth
													onGenderUpdate={onGenderUpdate}
													childId={childs.id}
												/>
											</div>
											{childs.Subscriptions.length > 0 ? (
												childs.Subscriptions.map((subscription: any) => (
													<div key={subscription.id}>
														<small className="text-center">
															Membership: {subscription.plan === 'premium' ? 'Premium' : 'Basic'}{' '}
														</small>
														<div className="mx-auto d-flex flex-column justify-content-center align-items-center mb-5">
															<CommonButton
																onClick={() => handlePremiumOpen(subscription.id)}
																common={{
																	width: '381.87px',
																	height: '48px',
																	background: '#FF7552',
																	radius: '200px',
																}}
																command="Cancel Membership"
															/>
														</div>
														{subscription.plan != 'premium' ? (
															<h4
																className={classes.removeKid}
																onClick={() => handleUpgradeSubscription(childs.id)}
															>
																Upgrade Subscription
															</h4>
														) : (
															''
														)}
													</div>
												))
											) : (
												<div>
													<small className="text-center">Not a Member?</small>
													<div className="mx-auto d-flex flex-column mb-5">
														<CommonButton
															onClick={() => handleOpen(childs.id)}
															common={{
																width: '381.87px',
																height: '48px',
																background: '#7FD6DD',
																radius: '200px',
																margin: '0 auto',
															}}
															command=" BECOME A MEMBER"
														/>
													</div>
													{open === true ? (
														<CustomModal open={open} handleClose={handleClose}>
															<ConditionalCard
																information="Do you want to create your subscription."
																heading={`Woah, ${currentChild}!`}
																conditions={conditions}
																onClick={() => handleModalClick('yes', childs.id)}
															/>
														</CustomModal>
													) : (
														''
													)}
												</div>
											)}
										</div>
									))}
							</ul>
							{premiumOpen == true ? (
								<CustomModal open={premiumOpen} handleClose={handlePremiumClose}>
									<ConditionalCard
										headingStyle
										information="Are you sure you want to cancel your subscription?"
										heading={`Eek!`}
										conditions={conditions}
										id={userSubID}
										image={CancelSubscription}
										onClick={handlePremiumModalClick}
									>
										<p style={{ color: '#E1705A' }}>
											All Information collected as part of this subscription will no longer be accessible.
										</p>
									</ConditionalCard>
								</CustomModal>
							) : (
								''
							)}
							{addANewKid && (
								<CustomModal open={addANewKid} handleClose={handleClose}>
									<div className={classes.addChildModal}>
										<form onSubmit={formik.handleSubmit}>
											<ul className={`${classes.listItems} text-center`}>
												<small className="text-center">Add a child</small>
												{child.map(element => (
													<li key={element.id} className="mt-2">
														<ReusableInput
															label={element.label}
															name={element.name}
															type={element.type}
															placeholder={element.placeholder}
															defaultValue={element.defaultValue}
															formik={formik}
															width={matches ? '250px' : '381.87px'}
															height="53.91px"
														/>
													</li>
												))}
											</ul>
											<div className="d-flex flex-column flex-wrap mx-auto mt-4 mb-3 justify-content-center align-items-center ">
												<section className="mb-3">
													<Selector itemList={list} gestation={setGestation} />
												</section>
												<CustomRadio genderChoice={setGender} items={radioButtonItems} componentWidth />
											</div>
											<div className="mx-auto d-flex flex-column justify-content-center align-items-center mb-5">
												<CommonButton
													common={{
														background: '#7FD6DD',
														radius: '5px',
													}}
													command={loading ? 'SAVE' : <ClipLoader color={'white'} loading={true} size={30} />}
												/>
											</div>
										</form>
									</div>
								</CustomModal>
							)}
							<div className="mx-auto d-flex flex-column justify-content-center align-items-center mb-3">
								<CommonButton
									onClick={openAddChildModal}
									common={{ width: '118.13px', height: '118.13px', background: '#7FD6DD', radius: '200px' }}
									addLineHeight="normal"
									command="Add Child"
								/>
								<CommonButton
									// onClick={() => history.push(Routes.Menu)}
									onClick={handlemysubmit}
									common={{
										width: '381.87px',
										height: '48px',
										background: '#7FD6DD',
										radius: '200px',
										margin: '0 auto',
									}}
									command="SAVE"
								/>
							</div>
						</div>
					</Background>
				</section>
			) : (
				<div className={classes.loading}>
					{errors ? (
						<Error errors={errors} />
					) : (
						<div className={classes.loading}>
							<h4>Wait a moment ...</h4>
							<ClipLoader color={'#7FD6DD'} loading={true} size={50} />
						</div>
					)}
				</div>
			)}
		</Fragment>
	);
};

export default AddDetails;
